import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-shield-flash-line text-lg text-white"></i>
                </div>
                <span className="font-heading font-bold text-lg text-white">网络安全守护</span>
              </div>
              <p className="text-sm leading-relaxed text-background-50/60">
                致力于普及网络安全知识，帮助每一位网民识别和防范流氓视频与网络诈骗，共建清朗网络空间。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm text-white mb-4">内容分类</h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/liuman-video-dingyi" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer">流氓视频定义</Link>
                <Link to="/category/shibie-exing-shipin" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer">识别恶意视频</Link>
                <Link to="/category/fangfan-cuoshi" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer">防范措施</Link>
                <Link to="/category/jubao-weiquan" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer">举报与维权</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm text-white mb-4">举报渠道</h4>
              <div className="flex flex-col gap-2">
                <a href="https://www.12321.cn" target="_blank" rel="nofollow noopener noreferrer" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer">12321举报中心</a>
                <a href="https://www.12377.cn" target="_blank" rel="nofollow noopener noreferrer" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer">12377违法举报</a>
                <span className="text-sm text-background-50/60">国家反诈中心APP</span>
                <span className="text-sm text-background-50/60">报警电话：110</span>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm text-white mb-4">关于本站</h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer">关于我们</Link>
                <Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer">最新文章</Link>
                <span className="text-sm text-background-50/60">联系邮箱：help@wangluoanquan.cn</span>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-50/40">
              &copy; {currentYear} 网络安全守护. 本站内容仅供学习参考，不构成法律建议。
            </p>
            <div className="flex items-center gap-5">
              <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}